module.exports = __webpack_public_path__ + "media/images/shipping-e83ba72e28ae0dec9b6457e2bb81f842.svg";